import React from 'react';
import Layout from '../../components/Layout/Layout';
import AdminMenu from '../../components/Layout/AdminMenu';
import '../../styles/AdminStyles.css';

const Users = () => {
  return (
    <Layout title={'جميع المستخدمين - النخبة ستور'}>
      <div className='container-fluid admin-layout'>
        <div className='row'>
          <div className='col-md-3'>
            <AdminMenu/>
          </div>
          <div className='col-md-9'>
            <div className="admin-page-header">
              <h1>المستخدمين</h1>
              <p>عرض وإدارة جميع المستخدمين المسجلين</p>
              <div className="admin-page-header-line"></div>
            </div>

            <div className="empty-state" style={{marginTop: '40px'}}>
              <div className="empty-state-icon">👥</div>
              <h4>إدارة المستخدمين</h4>
              <p>سيتم عرض قائمة المستخدمين هنا</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Users;
